import React from 'react';
import { View, Svg, Text, Polygon, Circle } from '@react-pdf/renderer';
import { OdontogramPdfStyles as S } from './styles';
import { Tooth } from '../../../../components/odontogram/odontogram.types';

interface OdontogramPdfProps {
  arcadaCima: Tooth[];
  arcadaBaixo: Tooth[];
  criancaCima: Tooth[];
  criancaBaixo: Tooth[];
}

const ToothPdf: React.FC<{ dente: Tooth }> = ({ dente }) => {
  const getStyleSafe = (className: string) => {
    if (!className) return undefined;

    const style = (S as any)[className];
    if (!style && className) {
      return (S as any)['none'];
    }
    return style;
  };

  return (
    <Svg width="28" height="28" viewBox="0 0 50 50">
      <Text style={S.toothNumber} x="25" y="8">
        {dente.numTooth}
      </Text>
      <Polygon
        points="10,10 50,10 40,20 20,20"
        style={getStyleSafe(dente.classes['class1']) || S.defaultFace}
      />
      <Polygon
        points="50,10 50,50 40,40 40,20"
        style={getStyleSafe(dente.classes['class2']) || S.defaultFace}
      />
      <Polygon
        points="50,50 10,50 20,40 40,40"
        style={getStyleSafe(dente.classes['class3']) || S.defaultFace}
      />
      <Polygon
        points="10,50 20,40 20,20 10,10"
        style={getStyleSafe(dente.classes['class4']) || S.defaultFace}
      />
      <Polygon
        points="20,20 40,20 40,40 20,40"
        style={getStyleSafe(dente.classes['class5']) || S.defaultFace}
      />

      {dente.classes['class6'] && (
        <Polygon
          points="10,15 15,10 50,45 45,50"
          style={getStyleSafe(dente.classes['class6'])}
        />
      )}

      {dente.classes['class7'] && (
        <Polygon
          points="45,10 50,15 15,50 10,45"
          style={getStyleSafe(dente.classes['class7'])}
        />
      )}

      {dente.classes['class8'] && (
        <Circle
          cx="30"
          cy="30"
          r="16"
          style={getStyleSafe(dente.classes['class8'])}
        />
      )}

      {dente.classes['class9'] && (
        <Circle
          cx="30"
          cy="30"
          r="20"
          style={getStyleSafe(dente.classes['class9'])}
        />
      )}

      {dente.classes['class10'] && (
        <Polygon
          points="50,10 40,10 10,26 10,32 46,32 10,50 20,50 50,36 50,28 14,28"
          style={getStyleSafe(dente.classes['class10'])}
        />
      )}
    </Svg>
  );
};

const ArcadaPdf: React.FC<{ arcada: Tooth[]; label: string }> = ({
  arcada,
  label,
}) => (
  <View style={S.arcadaContainer}>
    <Text style={S.arcadaLabel}>{label}</Text>
    <View style={S.arcadaRow}>
      {arcada.map((dente) => (
        <ToothPdf key={dente.id} dente={dente} />
      ))}
    </View>
  </View>
);

export const OdontogramPdf: React.FC<OdontogramPdfProps> = ({
  arcadaCima,
  arcadaBaixo,
  criancaCima,
  criancaBaixo,
}) => {
  return (
    <View style={S.container}>
      <ArcadaPdf arcada={arcadaCima} label="Arcada Superior - Adulto" />
      <ArcadaPdf arcada={criancaCima} label="Arcada Superior - Infantil" />
      <ArcadaPdf arcada={criancaBaixo} label="Arcada Inferior - Infantil" />
      <ArcadaPdf arcada={arcadaBaixo} label="Arcada Inferior - Adulto" />
    </View>
  );
};
